// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import successStoriesReducer from './data/successStoriesSlice';
import projectReducer from './data/projectSlice';
import bannerReducer from './data/bannerSlice';
import eventReducer from './data/eventSlice';
import authReducer from './data/authSlice';
import registrationReducer from './data/registrationSlice';
import memberReducer from './data/memberSlice';
import documentReducer from './data/documentSlice';

const store = configureStore({
  reducer: {
    successStories: successStoriesReducer,
    project: projectReducer,
    banners: bannerReducer,
    events: eventReducer,
    auth: authReducer,
    registrations: registrationReducer,
    members: memberReducer,
    documents: documentReducer,
  },
});

export default store;
